<template>
    <div>
      <canvas id="outerspace"></canvas>
    </div>
  </template>
  
  <script>
  export default {
    name: "StarfieldEffect",
    data() {
      return {
        canvasWidth: window.innerWidth, // Set to full screen width
        canvasHeight: window.innerHeight, // Set to full screen height
        numberOfStars: 500,
        stars: [],
        centerX: window.innerWidth / 2, // Half of screen width
        centerY: window.innerHeight / 2, // Half of screen height
      };
    },
    methods: {
      resizeCanvas() {
        const outerspace = document.getElementById("outerspace");

        if (!outerspace) {
          console.warn("'outerspace' not found.");
          return;
        }

        this.canvasWidth = window.innerWidth;
        this.canvasHeight = window.innerHeight;
        outerspace.width = this.canvasWidth;
        outerspace.height = this.canvasHeight;
        this.centerX = this.canvasWidth / 2;
        this.centerY = this.canvasHeight / 2;

        this.setup();
      },
      getRandomInt(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
      },
      remap(value, istart, istop, ostart, ostop) {
        return ((value - istart) / (istop - istart)) * (ostop - ostart) + ostart;
      },
      setup() {
        this.stars = []; // Clear stars array to avoid duplication
        for (let i = 0; i < this.numberOfStars; i++) {
          const star = {
            x: this.getRandomInt(-this.centerX, this.centerX),
            y: this.getRandomInt(-this.centerY, this.centerY),
            counter: this.getRandomInt(1, this.canvasWidth),
            radiusMax: this.getRandomInt(1, 10),
            speed: this.getRandomInt(5, 10),
          };
          this.stars.push(star);
        }
      },
      draw(mainContext) {
        // Clear the canvas
        mainContext.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
        mainContext.fillStyle = "#111";
        mainContext.fillRect(0, 0, this.canvasWidth, this.canvasHeight);
  
        // Translate context to the center
        mainContext.translate(this.centerX, this.centerY);
  
        // Draw stars
        this.stars.forEach((star) => {
          star.counter += star.speed;
  
          // Reset star position if it moves out of bounds
          if (star.counter > this.canvasWidth) {
            star.counter = 1;
            star.x = this.getRandomInt(-this.centerX, this.centerX);
            star.y = this.getRandomInt(-this.centerY, this.centerY);
          }
  
          const xRatio = star.x / star.counter;
          const yRatio = star.y / star.counter;
          const starX = this.remap(xRatio, 0, 1, 0, this.canvasWidth);
          const starY = this.remap(yRatio, 0, 1, 0, this.canvasHeight);
          const radius = this.remap(star.counter, 0, this.canvasWidth, star.radiusMax, 0);
  
          mainContext.beginPath();
          mainContext.arc(starX, starY, radius, 0, Math.PI * 2, false);
          mainContext.closePath();
          mainContext.fillStyle = "#FFF";
          mainContext.fill();
        });
  
        // Reset translation
        mainContext.translate(-this.centerX, -this.centerY);
  
        // Animate
        requestAnimationFrame(() => this.draw(mainContext));
      },
    },
    mounted() {
      const outerspace = document.getElementById("outerspace");
      const mainContext = outerspace.getContext("2d");
  
      // Set the initial canvas size
      outerspace.width = this.canvasWidth;
      outerspace.height = this.canvasHeight;
  
      // Initialize stars and start drawing
      this.setup();
      this.draw(mainContext);
  
      // Add a resize event listener to make the canvas responsive
      window.addEventListener("resize", this.resizeCanvas);
    },
    // beforeDestroy() {
    //   // Clean up the resize event listener when the component is destroyed
    //   window.removeEventListener("resize", this.resizeCanvas);
    // },
  };
  </script>
  
  <style scoped>
  body {
    margin: 0; /* Remove margin for full-screen effect */
  }
  #outerspace {
    display: block; /* Ensure canvas spans the whole screen */
    border: 3px solid #111;
    border-radius: 0px;
    filter: drop-shadow(0px 0px 10px #333);
  }
  </style>